export default __webpack_public_path__ + "static/stephen-hwang-resume-39073359f410d2b32bb1a3d2f3c9e858.pdf";